import classNames from 'classnames';

interface LayoutProps {
  children?: React.ReactNode | React.ReactNode[];
}

const ModalLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="relative pb-header-height">
      <div
        className={classNames(
          `mb-64 laptop:mb-128 mt-[146px] laptop:mt-[210px]`,
          'mx-16 laptop:mx-96'
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default ModalLayout;
